var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "editor",
        clickToClose: false,
        resizable: true,
        scrollable: true,
        reset: true,
        height: "auto",
        width: _vm.modalWidth,
        maxHeight: _vm.modalHeight,
      },
    },
    [
      _vm.editFileData.type == "img" || _vm.editFileData.type == "pdf"
        ? _c(
            "div",
            { staticClass: "dialogcontainer" },
            [
              _c("div", { staticClass: "centeringparent" }, [
                _c("img", {
                  staticClass: "thumbnailpreview",
                  attrs: { src: _vm.editFileData.requestUrl },
                }),
              ]),
              _c("destinations", {
                model: {
                  value: _vm.editFileData.dest,
                  callback: function ($$v) {
                    _vm.$set(_vm.editFileData, "dest", $$v)
                  },
                  expression: "editFileData.dest",
                },
              }),
              _c("ckeditor", {
                staticClass: "ck-editor-img-body",
                attrs: { editor: _vm.editor, config: _vm.headlineEditorConfig },
                on: {
                  ready: _vm.onBodyEditorReady,
                  focus: _vm.onBodyEditorFocus,
                  blur: _vm.onBodyEditorBlur,
                  input: _vm.onEditorInput,
                },
                model: {
                  value: _vm.editFileData.body,
                  callback: function ($$v) {
                    _vm.$set(_vm.editFileData, "body", $$v)
                  },
                  expression: "editFileData.body",
                },
              }),
              _vm.bodyEditing
                ? _c("div", { staticClass: "label" }, [
                    _c("p", { staticClass: "wordcount" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("editor.COUNTER_WORDS")) +
                          ": " +
                          _vm._s(_vm.bodyWordCount.words) +
                          "\n        " +
                          _vm._s(_vm.$t("editor.COUNTER_CHARS")) +
                          ": " +
                          _vm._s(_vm.bodyWordCount.chars) +
                          "\n      "
                      ),
                    ]),
                  ])
                : _c("div", { staticClass: "label" }, [
                    _c("p", { staticClass: "wordcount" }, [_vm._v(" ")]),
                  ]),
            ],
            1
          )
        : _vm.editFileData.type == "url" || _vm.editFileData.type == "any"
        ? _c(
            "div",
            { staticClass: "dialogcontainer" },
            [
              _c("p", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.$t("editor.FIELD_NAME"))),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.editFileData.name,
                    expression: "editFileData.name",
                  },
                ],
                staticClass: "field",
                domProps: { value: _vm.editFileData.name },
                on: {
                  change: _vm.onEditorInput,
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.editFileData, "name", $event.target.value)
                  },
                },
              }),
              _c("destinations", {
                model: {
                  value: _vm.editFileData.dest,
                  callback: function ($$v) {
                    _vm.$set(_vm.editFileData, "dest", $$v)
                  },
                  expression: "editFileData.dest",
                },
              }),
              _c("p", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.$t("editor.FIELD_HEADLINE")) + " "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.headlineCharValidationFailed(),
                        expression: "headlineCharValidationFailed()",
                      },
                    ],
                    staticClass: "validation-error",
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("editor.FIELD_HEADLINE_MAXCHARS", {
                          maxChars: _vm.headlineValidation.maxChars,
                          count: _vm.headlineWordCount.chars,
                        })
                      )
                    ),
                  ]
                ),
              ]),
              _c("ckeditor", {
                staticClass: "ck-editor_headline",
                attrs: { editor: _vm.editor, config: _vm.headlineEditorConfig },
                on: {
                  ready: _vm.onHeadlineEditorReady,
                  focus: _vm.onHeadlineEditorFocus,
                  blur: _vm.onHeadlineEditorBlur,
                  input: _vm.onEditorInput,
                },
                model: {
                  value: _vm.editFileData.headline,
                  callback: function ($$v) {
                    _vm.$set(_vm.editFileData, "headline", $$v)
                  },
                  expression: "editFileData.headline",
                },
              }),
              _vm.headlineEditing
                ? _c("div", { staticClass: "label" }, [
                    _c("p", { staticClass: "wordcount" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("editor.COUNTER_WORDS")) +
                          ": " +
                          _vm._s(_vm.headlineWordCount.words) +
                          "\n        "
                      ),
                      _c(
                        "span",
                        {
                          class: { error: _vm.headlineCharValidationFailed() },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("editor.COUNTER_CHARS")) +
                              ": " +
                              _vm._s(_vm.headlineWordCount.chars) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]),
                  ])
                : _c("div", { staticClass: "label" }, [
                    _c("p", { staticClass: "wordcount" }, [_vm._v(" ")]),
                  ]),
              _c("p", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.$t("editor.FIELD_LEAD"))),
              ]),
              _c("ckeditor", {
                staticClass: "ck-editor_lead",
                attrs: { editor: _vm.editor, config: _vm.leadEditorConfig },
                on: {
                  ready: _vm.onLeadEditorReady,
                  focus: _vm.onLeadEditorFocus,
                  blur: _vm.onLeadEditorBlur,
                  input: _vm.onEditorInput,
                },
                model: {
                  value: _vm.editFileData.lead,
                  callback: function ($$v) {
                    _vm.$set(_vm.editFileData, "lead", $$v)
                  },
                  expression: "editFileData.lead",
                },
              }),
              _vm.leadEditing
                ? _c("div", { staticClass: "label" }, [
                    _c("p", { staticClass: "wordcount" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("editor.COUNTER_WORDS")) +
                          ": " +
                          _vm._s(_vm.leadWordCount.words) +
                          "\n        " +
                          _vm._s(_vm.$t("editor.COUNTER_CHARS")) +
                          ":\n        " +
                          _vm._s(_vm.leadWordCount.chars) +
                          "\n      "
                      ),
                    ]),
                  ])
                : _c("div", { staticClass: "label" }, [
                    _c("p", { staticClass: "wordcount" }, [_vm._v(" ")]),
                  ]),
              _c("p", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.$t("editor.FIELD_BODY"))),
              ]),
              _c("ckeditor", {
                staticClass: "ck-editor_body",
                style: { "min-height": _vm.ckeditorBodyMinHeight },
                attrs: { editor: _vm.editor, config: _vm.editorConfig },
                on: {
                  ready: _vm.onBodyEditorReady,
                  focus: _vm.onBodyEditorFocus,
                  blur: _vm.onBodyEditorBlur,
                  input: _vm.onEditorInput,
                },
                model: {
                  value: _vm.editFileData.body,
                  callback: function ($$v) {
                    _vm.$set(_vm.editFileData, "body", $$v)
                  },
                  expression: "editFileData.body",
                },
              }),
              _vm.bodyEditing
                ? _c("div", { staticClass: "label" }, [
                    _c("p", { staticClass: "wordcount" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("editor.COUNTER_WORDS")) +
                          ": " +
                          _vm._s(_vm.bodyWordCount.words) +
                          "\n        " +
                          _vm._s(_vm.$t("editor.COUNTER_CHARS")) +
                          ": " +
                          _vm._s(_vm.bodyWordCount.chars) +
                          "\n      "
                      ),
                    ]),
                  ])
                : _c("div", { staticClass: "label" }, [
                    _c("p", { staticClass: "wordcount" }, [_vm._v(" ")]),
                  ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "buttonscontainer",
          staticStyle: { padding: "6px" },
          attrs: { align: "center" },
        },
        [
          _c(
            "button",
            { staticClass: "quicktextbutton", on: { click: _vm.onDiscard } },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("editor.BUTTON_DISCARD")) + "\n    "
              ),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "quicktextbutton",
              class: { disabled: _vm.validationFailed() },
              attrs: { disabled: _vm.validationFailed() },
              on: { click: _vm.onSave },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("editor.BUTTON_SAVE")) + "\n    "
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }